export const schools = [
  {
    organisation: "Singapore University of Technology and Design",
    role: "Doctor of Philosophy (Information Systems Technology and Design)",
    duration: "Sep 2024 - Present",
    description: [
      "Awarded the A*STAR Computing and Information Science (ACIS) Scholarship",
      "Researching on Human-AI Interaction and Sensitive Care Contexts (e.g., Mental Health, Advance Care Planning)",
    ],
  },
  {
    organisation: "University of California, Berkeley",
    role: "Berkeley Summer Sessions",
    duration: "Jun 2023 - Aug 2023",
    description: [
      "Under SUTD's Global Leadership Programme, a premier programme offered to scholarship recipients",
      "Completed coursework in Neurodiversity in Literature and Examining Sociocultural Issues through TikTok",
      "GPA 4.0/4.0",
    ],
  },
  {
    organisation: "Korea Advanced Institute of Science and Technology",
    role: "Exchange Programme",
    duration: "Feb 2023 - Jun 2023",
    description: [
      "Under SUTD's Global Exchange Programme",
      "Completed coursework in Data Science Methodology, Korean 1, Introduction to Artificial Intelligence, Introduction to Human-Computer Interaction, and Neural Computation",
      "GPA 3.4/4.3 (90.00/100)",
    ],
  },
  {
    organisation: "Hanyang University",
    role: "International Summer School",
    duration: "Jul 2021 - Aug 2021",
    description: [
      "Completed coursework in Gender and Korean Society, International Relations and The Rise of the Korean Wave",
      "GPA 4.33/4.5",
    ],
  },
  {
    organisation: "Singapore University of Technology and Design",
    role: "Bachelor of Engineering (Computer Science and Design) with Honours with Distinction",
    duration: "Sep 2020 - May 2024",
    description: [
      "Cumulative GPA: 4.44/5.0",
      "Minor in Healthcare Informatics",
      "Awarded the SUTD Global Distinguished Scholarship",
      "Was admitted to the SUTD-Duke-NUS Special Track, a pathway to pursue a Doctor of Medicine (MD) degree at Duke-NUS",
      "Attended 2 virtual Freshmore Asian Cross-curricular Trips: Global Humanities: Literature, Philosophy and Ethics @ Universiti Brunei Darussalam, and Designing Energy Systems @ Shenzhen Technology University",
      "Took part in various overseas exchange and summer programmes: Korea Advanced Institute of Science and Technology, Hanyang University, and University of California, Berkeley",
    ],
  },
  {
    organisation: "Ngee Ann Polytechnic",
    role: "Diploma in Engineering Science",
    duration: "Apr 2017 - Feb 2020",
    description: [
      "Cumulative GPA: 3.93/4.0 with 4 Module Prizes, 13 Distinctions",
      "Diploma Plus in Advanced Engineering Mathematics",
      "Certificate in China Readiness",
      "Enrichment Programme in Business Mandarin (A+ Grade)",
      "Awarded the A*STAR Science Award (Polytechnic) for AY2018/2019 and AY2019/2020, and the NP Engineering Scholarship for AY2017/2018",
      "Embarked on 5 overseas trips: Social Leadership Challenge in Taiwan, International Seminar on Technology for Sustainability in Bangkok, 7DRAGON Immersion Trip in Chongqing, Youth Expedition Project in Chiang Mai, and School of Engineering Induction Programme in Bintan",
      "Featured in NP School of Engineering's Outreach Brochures, Videos, and Websites. <a href=\"https://www.np.edu.sg/schools-courses/academic-schools/school-of-engineering/diploma-in-engineering-science\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Website</a> | <a href=\"https://www.youtube.com/watch?v=rhs2d30C3iI\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Video Showcase</a> | <a href=\"https://assets.app.optical.gov.sg/np/production/published/collections/pages/d65c5052-f95f-4fbc-9fc5-a33fbf734c51/91bc6ab8-0782-4c53-b248-91dcb5c45571.pdf\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Course Brochure</a>",
    ],
  },
  {
    organisation: "School of Science and Technology, Singapore",
    role: "GCE 'O' Levels",
    duration: "2013 - 2016",
    description: [
      "7 Distinctions, 1 Merit (Raw L1R5: 8, Raw L1R4: 6; Net L1R5: 6, Net L1R4: 4)",
      "Top GCE 'O' Level Performer 2016; Edusave Certificate of Academic Achievement 2016; Edusave Good Progress Award 2016",
      "Robotics @APEX (2013-2016): Represented SST in Bull's Eye, FIRST Lego League, and FIRST Tech Challenge; 1st place in Bull's Eye Competition 2013 (Category B); Best Presentation Award in FIRST Lego League 2015",
      "Global Citizenship Programme: Student visit to Ho Chi Minh City (2013); Student Leader visit to Beijing (2015), including an iBook on hutongs (胡同) shared at iSummit",
      "Class Vice-Chairperson (2013); Class Chairperson (2015)",
    ],
  },
];
